import { accounts, signup, login, getSession, logout } from "./auth.js";
// Browser-local evaluator login. This marker also requires the original account session; not production authorization.
export const WORKSPACE_KEY = "praachin-admin-direct-workspace-v1";
export function openWorkspace(session) {
  session.setItem(WORKSPACE_KEY, "credential-demo");
  return { name: "Local workspace", role: "local" };
}
export function getWorkspaceSession(storage, session) {
  const token = session.getItem("adminToken");
  const role = session.getItem("adminRole");
  const expiresAt = session.getItem("adminExpiresAtUtc");

  const validAdminSession =
    !!token &&
    role?.toLowerCase() === "admin" &&
    (!expiresAt ||
      (Number.isFinite(Date.parse(expiresAt)) &&
        Date.parse(expiresAt) > Date.now()));

  if (validAdminSession) {
    return {
      id: session.getItem("adminId"),
      name: session.getItem("adminName"),
      email: session.getItem("adminEmail"),
      role,
      token,
    };
  }

  return session.getItem(WORKSPACE_KEY) === "credential-demo"
    ? getSession(storage, session)
    : null;
}
export function closeWorkspace(session) {
  session.removeItem(WORKSPACE_KEY);
  logout(session);
}
export function assignCollectionProducts(
  db,
  collectionId,
  memberIds,
  destination,
) {
  const collection = db.collections.find(
    (c) => c.id === collectionId && !c.archived,
  );
  if (!collection) throw Error("Save a valid collection identity first.");
  const members = new Set(memberIds);
  if (
    [...members].some(
      (pid) => !db.products.some((p) => p.id === pid && !p.archived),
    )
  )
    throw Error("Select valid, non-archived products.");
  const removed = db.products.filter(
    (p) => !p.archived && p.collection === collectionId && !members.has(p.id),
  );
  if (
    removed.length &&
    !db.collections.some(
      (c) => c.id === destination && !c.archived && c.id !== collectionId,
    )
  )
    throw Error("Choose a destination for removed product members.");
  for (const p of db.products) {
    if (members.has(p.id)) p.collection = collectionId;
    else if (removed.some((r) => r.id === p.id)) p.collection = destination;
    const col = db.collections.find((c) => c.id === p.collection);
    if (!col?.launch && p.status === "Active") p.status = "Draft";
  }
}

// Public demo credentials only; never configure a production password here.
export async function loginWorkspace(storage, session, { username, password }) {
  const user = String(username || "").trim(),
    pass = String(password || "");
  if (!user || !pass) throw Error("Enter your username and password.");
  const email =
    user.toLowerCase() === "admin" ? "demo-admin@praachin.local" : user;
  if (
    email === "demo-admin@praachin.local" &&
    !accounts(storage).accounts.some((a) => a.email === email)
  ) {
    if (pass !== "PraachinDemo@2026")
      throw Error("Username or password is incorrect.");
    await signup(storage, {
      name: "Demo Administrator",
      email,
      password: pass,
      confirmPassword: pass,
    });
  }
  let account;
  try {
    account = await login(storage, session, { email, password: pass });
  } catch (error) {
    if (error.message === "Email or password is incorrect." || error.fields)
      throw Error("Username or password is incorrect.");
    throw error;
  }
  try {
    openWorkspace(session);
  } catch (error) {
    logout(session);
    throw error;
  }
  return account;
}
